import { Vue, Component, Prop } from 'vue-property-decorator';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

@Component({
    name: 'group-heirarchy',
    components: {

    },
})

export default class GroupHeirarchy extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedConfig: any;

    private selected = null;

    private options: any = ['1', '2', '3', '4'];

    // This properties value initialization for country seletion value
    private counrySelected = null;

    private stateSelected = null;

    private districtSelected = null;

    private indiaDistrictSelected = null;

    // This properties array value initialization for country list value
    private countryList: any = [];

    private stateList: any = [];

    private districtList: any = [];

    private indiaDistrictList: any = [];

    // Follow this property country value reassign the value
    private countryValue: any;
    // --------------------------------------------------------------------------
    // Actions


    // ----------------------------------------------------------------------
    // Methods
    public getCountrySelectedItem() {
        this.fetchStateLists(this.counrySelected);
    }

    public getStateSelectedItem() {
    this.countryValue = this.counrySelected;
    if (this.countryValue.code === 'IN' || this.countryValue.name === 'India') {
        this.fetchIndiaDistrictLists(this.stateSelected);
    } else {
        this.fetchDistrictLists(this.stateSelected);
    }
    }



     // ---------------------------------------------------------
    // Hooks
    private created() {
        this.fetchCountryLists();
        const settings = this.selectedConfig.tenantConfig;
        if (settings && settings.value) {
            this.selected = settings.value;
        }
    }

    private fetchCountryLists() {
        taxonomyAPI.fetchTaxonomyCountry().then((Country: any) => {
            if (Country.groups.length > 0) {
                this.countryList = Country.groups;
            }
        });
    }

    private fetchStateLists(country: any) {
        this.stateList = [];
        this.districtList = [];
        this.indiaDistrictList = [];
        taxonomyAPI.fetchTaxonomyState(country).then((State: any) => {
            if (State.groups.length > 0) {
               this.stateList = State.groups;
            }
        });
    }

    private fetchIndiaDistrictLists(State: any) {
        taxonomyAPI.fetchTaxonomyIndiaDistrict(State).then((IndiaDistrict: any) => {
            if (IndiaDistrict.groups.length > 0) {
                this.indiaDistrictList = IndiaDistrict.groups;
            }
        });
    }

    private fetchDistrictLists(State: any) {
        taxonomyAPI.fetchTaxonomyDistrict(State).then((District: any) => {
            if (District.groups.length > 0) {
                this.districtList = District.groups;
            }
        });
    }

    private onChangeConfig() {
        this.$emit('onChangeConfig', this.selected);
    }

}
